// global/subscription/subscription.dom

function createSub(dataSub) {
    var sub = $('<div class="box-thumb-channel">'+
        '<a name="url" class="thumb" href="">'+
            '<img name="thumb" src="">'+
        '</a>'+
        '<h3>'+
            '<a name="name" href="">'+
                '<span name="name-text"></span> <span name="verified" class="icon-ok-circled icono"></span>'+
            '</a>'+
        '</h3>'+
        '<p><strong><span name="n-videos"></span> videos</strong> | <span name="n-subscriptions" class="n-subscriptions"></span> subscribers</p>'+
        '<a name="subscribed" class="subscribe-channel btn-generico btn-subscribe" href="#" data-channel-id="">'+
            '<span class="icon-ok-circled icono"></span>'+
            '<span class="texto" data-text-subscribed="" data-text-subscribe=""></span>'+
        '</a>'+
    '</div>');
    
    $(sub).find("[name='thumb']").attr('src', dataSub.thumb);
    $(sub).find("[name='url'], [name='name']").attr('href', dataSub.url);
    $(sub).find("[name='name-text']").html(dataSub.name);
    $(sub).find("[name='n-videos']").text(dataSub.nVideos);
    $(sub).find("[name='n-subscriptions']").text(dataSub.subscriptions);
    $(sub).find("[name='subscribed']").data('channel-id', dataSub.id);
    $(sub).find("[name='subscribed'] .texto").data('text-subscribed', global_tokyvideo_text_subscribed).data('text-subscribe', global_tokyvideo_text_subscribe);

    if (!dataSub.verified) {
        $(sub).find("[name='verified']").remove();
    }
        
    if (dataSub.subscribed) {
        $(sub).find("[name='subscribed']").addClass('btn-verde');
        $(sub).find("[name='subscribed'] .texto").html(global_tokyvideo_text_subscribed);
    } else {
        $(sub).find("[name='subscribed']").addClass('btn-naranja');
        $(sub).find("[name='subscribed'] .texto").html(global_tokyvideo_text_subscribe);
    }
    
    // inicializamos evento suscribirse
    initSubscriptionChannels(sub);
    
    return sub;
}

function createSubList(dataSub) {
    var sub = $('<div class="box-list-channel">'+
        '<a name="url" class="thumb" href="">'+
            '<img name="thumb" src="">'+
        '</a>'+
        '<div class="data">'+
            '<h3>'+
                '<a name="name" href="">'+
                    '<span name="name-text"></span> <span name="verified" class="icon-ok-circled icono"></span>'+
                '</a>'+
            '</h3>'+
            '<p><strong><span name="n-videos"></span> videos</strong> | <span name="n-subscriptions" class="n-subscriptions"></span> subscribers</p>'+
        '</div>'+
        '<a name="subscribed" class="subscribe-channel btn-generico btn-subscribe" href="#" data-channel-id="">'+
            '<span class="icon-ok-circled icono"></span>'+
            '<span data-text-subscribe="" data-text-subscribed="" class="texto"></span>'+
        '</a>'+
        '<div class="clear"></div>'+
    '</div>');
    
    $(sub).find("[name='thumb']").attr('src', dataSub.thumb);
    $(sub).find("[name='url'], [name='name']").attr('href', dataSub.url);
    $(sub).find("[name='name-text']").html(dataSub.name);
    $(sub).find("[name='n-videos']").text(dataSub.nVideos);
    $(sub).find("[name='n-subscriptions']").text(dataSub.subscriptions);
    $(sub).find("[name='subscribed']").data('channel-id', dataSub.id);
    $(sub).find("[name='subscribed'] .texto").data('text-subscribed', global_tokyvideo_text_subscribed).data('text-subscribe', global_tokyvideo_text_subscribe);
    
    if (!dataSub.verified) {
        $(sub).find("[name='verified']").remove();
    }

    if (dataSub.subscribed) {
        $(sub).find("[name='subscribed']").addClass('btn-verde');
        $(sub).find("[name='subscribed'] .texto").html(global_tokyvideo_text_subscribed);
    } else {
        $(sub).find("[name='subscribed']").addClass('btn-naranja');
        $(sub).find("[name='subscribed'] .texto").html(global_tokyvideo_text_subscribe);
    }
    
    // inicializamos evento suscribirse
    initSubscriptionChannels(sub);
    
    return sub;
}
